module.exports = __webpack_public_path__ + "static/media/registration_closed.ff0a9e6c.jpg";